// export class DeferredPromise implements BasicDeferredPromise {
//   reject?: Rejector;
//   timeCreated: Date;

import { CallResult, Contact, GenericResult, HangupResult, HoldToggleResult, MuteToggleResult, ParticipantResult, PhoneCall } from '@salesforce/scv-connector-base';

//   constructor() {
//     this.timeCreated = new Date();
//   }
// }


// export class CallResultDeferredPromise implements T_DeferredPromise {
//   kind = "CallResult";
//   promise: Promise<CallResult>;
type GenericResolver<T> = (value: T) => void;
type Resolver =
  GenericResolver<CallResult> |
  GenericResolver<GenericResult> |
  GenericResolver<string | undefined> |
  GenericResolver<HangupResult> |
  GenericResolver<MuteToggleResult> |
  GenericResolver<HoldToggleResult> |
  GenericResolver<boolean> |
  GenericResolver<ParticipantResult>
;
type Rejector = (reason?: Error) => void;


export type DeferredPromiseKind =
  'AcceptReject' |
  'AgentStatus' |
  'Logout' |
  'Hangup' |
  'Mute' |
  'Hold' |
  'Participant' |
  'Conference' |
  'OutboundDial' |
  'BlindTransfer' |
  'PendingMerge' |
  'AgentStatusEcho'
;

interface BlindTransferPromiseDetails {
  contact: Contact;
  call: PhoneCall;
};

interface HangupPromiseDetails {
  callId: string;
  raiseAsUnsolicited: boolean;
}

interface CallResultPromiseDetails {callId: string}

interface AgentStatusPromiseDetails {
  presence: string;
  reason?: string;
  pending: boolean;
};

interface ParticipantPromiseDetails {
  call: PhoneCall;
  contact: Contact;
  isBlindTransfer: boolean;
};

interface ConferencePromiseDetails {
  calls: PhoneCall[];
};

interface OutboundDialPromiseDetails {
  phoneNumber: string;
};

interface PendingMergePromiseDetails {
  interactionId: string;
  scenarioId: string;
}

interface AgentStatusEchoPromiseDetails {
  statusId: string;
}

type DeferredPromiseDetails =
  CallResultPromiseDetails |
  AgentStatusPromiseDetails |
  ParticipantPromiseDetails |
  ConferencePromiseDetails |
  HangupPromiseDetails |
  OutboundDialPromiseDetails |
  BlindTransferPromiseDetails |
  PendingMergePromiseDetails |
  AgentStatusEchoPromiseDetails |
  undefined
;
export abstract class DeferredPromise {
  private static globalId = 0;

  abstract kind: DeferredPromiseKind;
  abstract promise: Promise<unknown>;
  abstract resolve?: Resolver;
  abstract reject?: Rejector;
  private _pending: boolean;
  get pending(): boolean {
    return this._pending;
  }
  id: number;
  timeCreated: Date;
  timeoutHandle: ReturnType<typeof setTimeout>;
  abstract additionalDetails: DeferredPromiseDetails;

  constructor() {
    this.timeCreated = new Date();
    this._pending = true;
    this.id = DeferredPromise.globalId++; // set id for this instance, then increment global (static) id counter
    this.timeoutHandle = setTimeout(() => undefined, 0);
    clearTimeout(this.timeoutHandle);
    this.generatePromise();
  }

  private generatePromise(): void {
    this.promise = new Promise((res, rej) => {
      this.resolve = function(value: unknown): void {
        this._pending = false;
        res(value);
      };
      this.reject = function(reason?: Error): void {
        this._pending = false;

        // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
        rej(reason);
      };
    });
  }
}

export class OutboundDialDeferredPromise extends DeferredPromise {
  kind: DeferredPromiseKind = 'OutboundDial';
  promise!: Promise<CallResult>;
  resolve?: GenericResolver<CallResult>;
  reject?: Rejector;
  additionalDetails: OutboundDialPromiseDetails;

  constructor(details: OutboundDialPromiseDetails) {
    super();
    this.additionalDetails = details;
  }
}
export class AcceptRejectDeferredPromise extends DeferredPromise {
  kind: DeferredPromiseKind = 'AcceptReject';
  promise!: Promise<CallResult>;
  resolve?: GenericResolver<CallResult>;
  reject?: Rejector;
  additionalDetails: CallResultPromiseDetails;
  isAccept: boolean;

  constructor(details: CallResultPromiseDetails, isAccept: boolean) {
    super();
    this.additionalDetails = details;
    this.isAccept = isAccept;
  }
}

export class PresenceDeferredPromise extends DeferredPromise {
  kind: DeferredPromiseKind = 'AgentStatus';
  promise!: Promise<GenericResult>;
  resolve?: GenericResolver<GenericResult>;
  reject?: Rejector;
  additionalDetails: AgentStatusPromiseDetails;

  constructor(details: AgentStatusPromiseDetails) {
    super();
    this.additionalDetails = details;
  }
}

export class AgentStatusEchoDeferredPromise extends DeferredPromise {
  kind: DeferredPromiseKind = 'AgentStatusEcho';
  promise!: Promise<GenericResult>;
  resolve?: GenericResolver<GenericResult>;
  reject?: Rejector;
  additionalDetails: AgentStatusEchoPromiseDetails;

  constructor(details: AgentStatusEchoPromiseDetails) {
    super();
    this.additionalDetails = details;
  }
}

export class LogoutDeferredPromise extends DeferredPromise {
  kind: DeferredPromiseKind = 'Logout';
  promise!: Promise<string | undefined>;
  resolve?: GenericResolver<string | undefined>;
  reject?: Rejector;
  additionalDetails: undefined;
}

export class HangupDeferredPromise extends DeferredPromise {
  kind: DeferredPromiseKind = 'Hangup';
  promise!: Promise<HangupResult>;
  resolve?: GenericResolver<HangupResult>;
  reject?: Rejector;
  additionalDetails: HangupPromiseDetails;

  constructor(details: HangupPromiseDetails) {
    super();
    this.additionalDetails = details;
  }
}

export class BlindTransferDeferredPromise extends DeferredPromise {
  kind: DeferredPromiseKind = 'BlindTransfer';
  promise!: Promise<ParticipantResult>;
  resolve?: GenericResolver<ParticipantResult>;
  reject?: Rejector;
  additionalDetails: BlindTransferPromiseDetails;

  constructor(details: BlindTransferPromiseDetails) {
    super();
    this.additionalDetails = details;
  }
}

export class MuteToggleDeferredPromise extends DeferredPromise {
  kind: DeferredPromiseKind = 'Mute';
  promise!: Promise<MuteToggleResult>;
  resolve?: GenericResolver<MuteToggleResult>;
  reject?: Rejector;
  additionalDetails: CallResultPromiseDetails;

  constructor(details: CallResultPromiseDetails) {
    super();
    this.additionalDetails = details;
  }
}

export class HoldToggleDeferredPromise extends DeferredPromise {
  kind: DeferredPromiseKind = 'Hold';
  promise!: Promise<HoldToggleResult>;
  resolve?: GenericResolver<HoldToggleResult>;
  reject?: Rejector;
  additionalDetails: CallResultPromiseDetails;

  constructor(details: CallResultPromiseDetails) {
    super();
    this.additionalDetails = details;
  }
}

export class ParticipantDeferredPromise extends DeferredPromise {
  kind: DeferredPromiseKind = 'Participant';
  promise!: Promise<ParticipantResult>;
  resolve?: GenericResolver<ParticipantResult>;
  reject?: Rejector;
  additionalDetails: ParticipantPromiseDetails;

  constructor(details: ParticipantPromiseDetails) {
    super();
    this.additionalDetails = details;
  }
}

export class ConferenceDeferredPromise extends DeferredPromise {
  kind: DeferredPromiseKind = 'Conference';
  promise!: Promise<HoldToggleResult>;
  resolve?: GenericResolver<HoldToggleResult>;
  reject?: Rejector;
  additionalDetails: ConferencePromiseDetails;

  constructor(details: ConferencePromiseDetails) {
    super();
    this.additionalDetails = details;
  }
}

export class PendingMergeDeferredPromise extends DeferredPromise {
  kind: DeferredPromiseKind = 'PendingMerge';
  promise!: Promise<boolean>;
  resolve?: GenericResolver<boolean>;
  reject?: Rejector;
  additionalDetails: PendingMergePromiseDetails;

  constructor(details: PendingMergePromiseDetails) {
    super();
    this.additionalDetails = details;
  }
}
